<template>
    <div class="container">
    <h2 class="text-center hidden-xs"><i class="fa fa-paw "></i> Manage your Pets info</h2>
    <h4 class="text-center hidden-sm hidden-md hidden-lg"><i class="fa fa-paw "></i> Manage your Pets info</h4>
           <ul class="nav nav-tabs">
              
                <router-link active-class="active" tag="li" to="/pets-view/mypets">
                    <a>My Pets</a>
                </router-link>

                <router-link active-class="active" tag="li" to="/pets-view/addpet">
                    <a>Add Pet</a>
                </router-link>

            </ul>

                
            <div class="tab-content">
                 <router-view></router-view>
            </div>
                
            

     
        
            
        
    </div>
</template>
<script>


import router from '../../router/index.js'


    export default {
    name: '' , 
    data() {
        return {
            
        };
    },
    mounted: function() {
      if (this.$route.path=='/pets-view')
            router.push({path: '/pets-view/mypets'})
    },
    components: {
    },
    computed: {
        
    }
}

</script>


<style scoped>


.list-flex{
       display: -webkit-flex;
           display: flex;
           -webkit-flex-direction: row;
           flex-direction: row;
           -webkit-align-items: center;
           align-items: center;
           
           flex-wrap: wrap;
}



</style>


// WEBPACK FOOTER //
// PetsView.vue?52e4f20b